import type { SVGProps } from 'react';
import RadarScanIcon from '@/components/service-showcase/icons/RadarScanIcon';
import SignalMeshIcon from '@/components/service-showcase/icons/SignalMeshIcon';
import OrbitLoopIcon from '@/components/service-showcase/icons/OrbitLoopIcon';
import ProductFlowIcon from '@/components/service-showcase/icons/ProductFlowIcon';
import ConstellationMapIcon from '@/components/service-showcase/icons/ConstellationMapIcon';
import ConcentricTargetIcon from '@/components/service-showcase/icons/ConcentricTargetIcon';
import OperationalLiftIcon from '@/components/service-showcase/icons/OperationalLiftIcon';
import ProductSurfaceIcon from '@/components/service-showcase/icons/ProductSurfaceIcon';
import type { IServiceShowcaseSvgIconProps } from '@/components/service-showcase/icons/type';

export const SERVICE_SHOWCASE_ICON_OPTIONS = [
  { value: 'radar-scan', label: 'Radar scan' },
  { value: 'signal-mesh', label: 'Signal mesh' },
  { value: 'orbit-loop', label: 'Orbit loop' },
  { value: 'product-flow', label: 'Product flow' },
  { value: 'constellation-map', label: 'Constellation map' },
  { value: 'concentric-target', label: 'Concentric target' },
  { value: 'operational-lift', label: 'Operational lift' },
  { value: 'product-surface', label: 'Product surface' },
] as const;

export type ServiceShowcaseIconName = (typeof SERVICE_SHOWCASE_ICON_OPTIONS)[number]['value'];

export interface IServiceShowcaseIconProps extends SVGProps<SVGSVGElement> {
  icon?: ServiceShowcaseIconName;
  active?: boolean;
}

const ICON_COMPONENTS = {
  'radar-scan': RadarScanIcon,
  'signal-mesh': SignalMeshIcon,
  'orbit-loop': OrbitLoopIcon,
  'product-flow': ProductFlowIcon,
  'constellation-map': ConstellationMapIcon,
  'concentric-target': ConcentricTargetIcon,
  'operational-lift': OperationalLiftIcon,
  'product-surface': ProductSurfaceIcon,
} satisfies Record<ServiceShowcaseIconName, (props: IServiceShowcaseSvgIconProps) => React.JSX.Element>;

export { OrbitLoopIcon, ProductFlowIcon, RadarScanIcon, SignalMeshIcon, ConstellationMapIcon, ConcentricTargetIcon, OperationalLiftIcon, ProductSurfaceIcon };

export default function ServiceShowcaseIcon(props: IServiceShowcaseIconProps) {
  const { icon, ...rest } = props;
  if (!icon) return null;

  const Icon = ICON_COMPONENTS[icon];
  return <Icon {...rest} />;
}
